import styled from 'styled-components';

import Grid from '@material-ui/core/Grid';

export const DialogContainer = styled(Grid).attrs({container: true, spacing: 2})`
  margin-bottom: 10px;
`;
